import {useMutation, useQuery} from '@tanstack/react-query';

import {
  RQ_DELETE_IMAGES_API,
  RQ_GET_ALL_IMAGES_API,
  RQ_POST_IMAGES_API,
  RQ_PUT_UPDATE_IMAGES_API,
} from './constants';
import {rqCreateMultipartRequest, rqCreateRequest} from './rqHttpUtils';

export const RQGetAllHomeImagesAPI = () => {
  return useQuery({
    queryKey: ['rq_get_all_home_images'],
    queryFn: async () => {
      const response = await rqCreateRequest(
        RQ_GET_ALL_IMAGES_API,
        null,
      );
      return response || [];
    },
    refetchOnWindowFocus: false,
    retry: 1,
  });
};

export const RQRegisterHomeImagesAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_register_home_images'],
    mutationFn: async ({token, formData}) => {
      return rqCreateRequest(
        RQ_POST_IMAGES_API,
        formData,
        token,
        null,
      );
    },
    ...options,
  });
};

export const RQUpdateHomeImagesAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_update_home_images'],
    mutationFn: async ({token, formData, id}) => {
      const url = RQ_PUT_UPDATE_IMAGES_API.url.replace('<%= id %>', id);

      try {
        const response = await rqCreateMultipartRequest(
          {...RQ_PUT_UPDATE_IMAGES_API, url},
          formData,
          token,
          null,
        );
        return response;
      } catch (error) {
        console.error('Error updating home images:', error);
        throw error;
      }
    },
    ...options,
  });
};

export const RQDeleteHomeImagesAPI = (options = {}) => {
  return useMutation({
    mutationKey: ['rq_delete_home_images'],
    mutationFn: async ({token, id}) => {
      if (!token) {
        throw new Error('Token is required');
      }

      const url = RQ_DELETE_IMAGES_API.url.replace('<%= id %>', id);

      try {
        const response = await rqCreateRequest(
          {...RQ_DELETE_IMAGES_API, url},
          null,
          token,
          null,
          null,
        );
        return response;
      } catch (error) {
        console.error('Error deleting home images:', error);
        throw error;
      }
    },
    ...options,
  });
};
